import { updateInterpolationParams } from '@gig/magic-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function setCompetitionParams(competitions) {
  return __async(this, null, function* () {
    const paramsAndValues = [];
    const competitionParams = [
      "currentProgress",
      "completedMilestones",
      "totalMilestones"
    ];
    competitions.forEach((competition) => {
      competitionParams.forEach((param) => {
        var _a;
        let calculatedValue;
        switch (param) {
          case "currentProgress":
            calculatedValue = competition.achievementValue;
            break;
          case "totalMilestones":
            calculatedValue = (_a = competition.milestones) == null ? void 0 : _a.length;
            break;
          case "completedMilestones":
            calculatedValue = getCompletedMilestones(competition);
            break;
        }
        paramsAndValues.push({
          parameter: competition.slug + "." + param,
          value: calculatedValue
        });
      });
    });
    const competitionInterpolationParams = paramsAndValues.reduce((acc, cur) => __spreadProps(__spreadValues({}, acc), { [cur.parameter]: cur.value !== void 0 ? cur.value.toString() : "" }), {});
    updateInterpolationParams(__spreadValues({}, Object.assign(competitionInterpolationParams)));
  });
}
function getCompletedMilestones(competition) {
  var _a;
  if (competition.milestones && competition.milestones.length > 0) {
    const achievementValue = (_a = competition.achievementValue) != null ? _a : 0;
    let mileStoneCompleted = 0;
    for (const milestone of competition.milestones) {
      if (achievementValue >= milestone.value) {
        mileStoneCompleted++;
      }
    }
    return mileStoneCompleted;
  } else {
    return 0;
  }
}

export { setCompetitionParams };
